import MenuIcon from "@mui/icons-material/Menu";
import { useMenu } from "../contexts/menuContext";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
export default function Header({ headerColor, hoverColor, shadowColor }) {
  let { openMenu } = useMenu();

  return (
    <div
      className="header"
      style={{
        // width: "100%",
        color: headerColor,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "30px",
        fontWeight: "300",
      }}
    >
      <Link to="/">
        <h3 className="taim-name" style={{ fontWeight: "normal" }}>
          <span style={{ marginRight: "5px" }}>&copy;</span>
          Code by Taim Jaber
          {/* <span >Tamer's Brother</span> */}
        </h3>
      </Link>
      <nav
        className="nav-bar"
        style={{
          display: "flex",
          listStyle: "none",
          margin: "0 20px",
          fontWeight: "normal",
        }}
      >
        <Link to="/work">
          <motion.h3
            className="menu-element"
            initial="initial"
            whileHover="hovered"
            style={{ position: "relative", overflow: "hidden" }}
          >
            <motion.span
              variants={{ initial: { y: 0 }, hovered: { y: "-100%" } }}
              transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
              style={{ display: "block", fontWeight: "normal" }}
            >
              Work
            </motion.span>
            <motion.span
              variants={{ initial: { y: "100%" }, hovered: { y: 0 } }}
              transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
              style={{
                display: "block",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                fontWeight: "normal",
              }}
            >
              Work
            </motion.span>
          </motion.h3>
        </Link>
        <Link to="/about">
          <motion.h3
            className="menu-element"
            initial="initial"
            whileHover="hovered"
            style={{
              margin: "0 30px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <motion.span
              variants={{ initial: { y: 0 }, hovered: { y: "-100%" } }}
              transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
              style={{ display: "block", fontWeight: "normal" }}
            >
              About
            </motion.span>
            <motion.span
              variants={{ initial: { y: "100%" }, hovered: { y: 0 } }}
              transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
              style={{
                display: "block",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                fontWeight: "normal",
              }}
            >
              About
            </motion.span>
          </motion.h3>
        </Link>
        <Link to="/contact">
          <motion.h3
            className="menu-element"
            initial="initial"
            whileHover="hovered"
            style={{ position: "relative", overflow: "hidden" }}
          >
            <motion.span
              variants={{ initial: { y: 0 }, hovered: { y: "-100%" } }}
              transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
              style={{ display: "block", fontWeight: "normal" }}
            >
              Contact
            </motion.span>
            <motion.span
              variants={{ initial: { y: "100%" }, hovered: { y: 0 } }}
              transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
              style={{
                display: "block",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                fontWeight: "normal",
              }}
            >
              Contact
            </motion.span>
          </motion.h3>
        </Link>
        <h3 className="menu-icon" style={{ display: "none" }}>
          <button
            style={{
              backgroundColor: "transparent",
              color: headerColor,
              border: "none",
              position: "relative",
              zIndex: "500",
              height: "100%",
              width: "100%",
            }}
            onClick={() => openMenu()}
          >
            <MenuIcon style={{ fontSize: "40px", cursor: "pointer" }} />
          </button>
        </h3>
      </nav>
    </div>
  );
}
